<div class="flex flex-col top-chatbot-container gap-1 items-center ">
  <div class="chatbot-chat-container h-[7.5rem] w-full" [class.limit-reached]="limitReached()" role="region" aria-label="Chat input">
    <!-- Main input container with message area and action buttons -->
    
    <!-- Voice dictation button -->
    <button
      type="button"
      class="voice-record-button dsr-mat-icon-button-filled"
      [class.dsr-mat-icon-button-small]="isRecording()"
      color="primary"
      matIconButton
      [attr.aria-label]="isRecording() ? 'Stop recording' : 'Start voice dictation'"
      [class.recording]="isRecording()"
      [disabled]="limitReached() || isTranscribing()"
      (click)="toggleRecording()">
      @if(isRecording()) {
        <dsr-icon aria-hidden="true" [size]="'12px'" [name]="'media-stop'"></dsr-icon>
      } @else {
        <dsr-icon aria-hidden="true" [name]="'microphone'"></dsr-icon>
      }
    </button>

    <div class="chatbot-input-container">
      
      <!-- Text input area for chat messages -->
      <label for="chatbot-input" class="sr-only">Chat message input</label>
      @if(!isRecording() && !isTranscribing()) {
        <textarea
        id="chatbot-input"
        class="chatbot-input dsr-typescale-body-small"
        matInput
        type="text"
        [readonly]="limitReached()"
        [formControl]="message()"
        [attr.placeholder]="limitReached() ? ('CHATBOT_LIMIT_PLACEHOLDER' | translate) : ''"
        aria-label="Chat message input"
        (keydown.enter)="onEnterPressed($event)"
        (input)="onMessageInput()"
        maxlength="{{ CHATBOT_CHAR_LIMIT }}"></textarea>}

      <!-- Recording / transcribing indicator overlay -->
      @if (isRecording()) {
        <div class="voice-indicator" role="status" aria-live="polite">
          <!-- <span class="voice-indicator-dot" aria-hidden="true"></span> -->
          <span class="voice-waveform" aria-hidden="true">
            @for (level of audioLevels(); track $index) {
              <span class="voice-bar" [style.height.%]="level * 100"></span>
            }
          </span>
          <!-- <div class=""><span class="voice-indicator-label dsr-typescale-body-small">{{ 'CHATBOT_RECORDING' | translate }}</span></div> -->
        </div>
      } @else if (isTranscribing()) {
        <div class="voice-indicator transcribing" role="status" aria-live="polite">
          <span class="voice-indicator-label dsr-typescale-body-small">{{ 'CHATBOT_TRANSCRIBING' | translate }}</span>
        </div>
      }
    </div>
  
    

    <!-- Send message button -->
    <button
      type="button"
      class="send-message-button"
      matIconButton
      aria-label="Send message"
      color="primary"
      [disabled]="!canSendMessage() || limitReached()"
      (click)="onsubmitBtnClicked()">
      <dsr-icon aria-hidden="true" name="navigation"></dsr-icon>
    </button>
  </div>
  <div class="flex justify-between items-center w-full px-2">
      <span class="dsr-typescale-body-small limit">
        {{ chatbotCharCount() }} / {{ CHATBOT_CHAR_LIMIT }}
      </span>
      <span class="dsr-typescale-body-small message-counter" [style.color]="messageCounterColor">
        <dsr-icon name="speechcomment" size="1.2rem" [color]="messageCounterColor" aria-hidden="true"></dsr-icon>
        {{ remainingMessages() }}
      </span>
    </div>
</div>
